import { organizationClient } from 'better-auth/client/plugins'
import { createAccessControl } from 'better-auth/plugins/access'
import { adminAc, defaultStatements, memberAc, ownerAc } from 'better-auth/plugins/organization/access'
import { createAuthClient } from 'better-auth/react'

// mirrors apps/api/src/auth.ts: the roles Better Auth accepts for invitations and role changes
const ac = createAccessControl(defaultStatements)
const roles = {
  owner: ac.newRole(ownerAc.statements),
  admin: ac.newRole(adminAc.statements),
  billing: ac.newRole(memberAc.statements),
  developer: ac.newRole(memberAc.statements),
  viewer: ac.newRole(memberAc.statements),
}

/** Same-origin: the API is mounted at /api on the console's own host. */
export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: '/api/auth',
  plugins: [organizationClient({ ac, roles })],
})
